import React from 'react';

const StoreConnect = React.lazy(() => import('../../modules/account/StoreConnect'));

export const storeConnectRoutesConfig = [
  {
    path: '/StoreConnect',
    element: <StoreConnect />,
  },
];
